<template>
  <div class="ob" :class="{ 'is-busy': submitting }">
    <header class="ob-top">
      <span class="ob-mark">Smartbooks</span>
    </header>
    <main class="ob-main">
      <p class="ob-kicker">Welcome back</p>
      <h1 class="ob-title">Sign in.</h1>
      <p class="ob-lead">The diary that looks after the chair.</p>
      <p v-if="error" class="ob-error">{{ error }}</p>
      <form class="ob-stack" @submit.prevent="doLogin">
        <label class="ob-field">
          Email
          <input
            v-model="formData.email"
            type="email"
            name="email"
            autocomplete="email"
            required
          />
        </label>
        <label class="ob-field">
          Password
          <input
            v-model="formData.password"
            type="password"
            name="password"
            autocomplete="current-password"
            required
          />
        </label>
        <button class="ob-primary" type="submit" :disabled="submitting || !canSubmit">
          Sign in
        </button>
        <button
          class="ob-ghost"
          type="button"
          :disabled="submitting"
          @click="doLoginWithGoogle"
        >
          Continue with Google
        </button>
        <router-link class="ob-link" to="/auth/reset-password">
          Forgot password
        </router-link>
        <router-link class="ob-link" to="/start">New shop? Open a book</router-link>
      </form>
    </main>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import { errorMessage } from "@/helpers/bookingSearch";
import { captureVerifyToken } from "@/helpers/onboard";

export default {
  data() {
    return {
      submitting: false,
      error: "",
      formData: {
        email: "",
        password: ""
      }
    };
  },
  computed: {
    canSubmit() {
      return !!(this.formData.email.trim() && this.formData.password);
    }
  },
  methods: {
    ...mapActions(["login", "loginWithGoogle", "verifyUser"]),
    async onSuccess() {
      const token = captureVerifyToken(this.$route);
      if (token) {
        try {
          await this.verifyUser({ token });
        } catch (error) {
          /* continue; /start will ask again if needed */
        }
      }
      const next = this.$route.query.next_url || "/start";
      this.$router.push(next).catch(() => {});
    },
    async doLogin() {
      if (!this.canSubmit || this.submitting) return;
      this.submitting = true;
      this.error = "";
      try {
        await this.login(this.formData);
        await this.onSuccess();
      } catch (error) {
        this.submitting = false;
        this.error = errorMessage(error, "Could not sign in.");
      }
    },
    async doLoginWithGoogle() {
      if (this.submitting) return;
      this.submitting = true;
      this.error = "";
      try {
        await this.loginWithGoogle();
        await this.onSuccess();
      } catch (error) {
        this.submitting = false;
        this.error = errorMessage(error, "Google sign-in failed.");
      }
    }
  }
};
</script>
